import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { ThemedView } from '@app/theme'
import Typography from '@sharedComponents/typography/Typography'
import BackButton from '@sharedComponents/BackButton/BackButton'
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema'
import useSingleRemoteConfig from '@app/hooks/useSingleRemoteConfig'
import ScreenWrapper from '@app/hoc/ScreenWrapper'


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'PRODUCT_DETAILS'>

type ProductDetailsData = {
    label : string,
    value : string
}[]

const ProductDetails = ({ navigation , route }: ScreenProps) => {

    const { configValue, loading } = useSingleRemoteConfig('product_details')

    const productDetails : ProductDetailsData = configValue ? JSON.parse(configValue) : []


    if (loading) {
        return <ThemedView bg='bg-surface-primary' flex={1} justifyContent='center' alignItems='center'>
      <ActivityIndicator color={'#1434CB'} size={12} />
        </ThemedView>
    }
    return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true }}>
        <ThemedView bg='bg-surface-primary' flex={1}>
            <ThemedView borderBottomWidth={1} borderBottomColor='border-secondary' p='lg' flexDirection='row' alignItems='center'>
                <ThemedView mr='md'>
                    <BackButton navigation={navigation} />
                </ThemedView>
                <Typography label='Product details' color={ColorTokens.Grey_Night} />
            </ThemedView>
            <ThemedView padding='lg' pt='2xl'>
                <Typography
                    typeDLS={TypographyTypeDLS.B1S}
                    label={'Loan against securities'}
                    color={ColorTokens.Grey_Night}
                />
                <ThemedView style={{ marginTop: 16, backgroundColor: '#FFF', borderWidth: 1, borderColor: '#F1F3F5', borderRadius: 6, paddingHorizontal: 12, paddingVertical: 16 }}>
                    {productDetails.map((item, i) => {
                        return (
                            <>
                                <ThemedView flexDirection='row' justifyContent={'space-between'}>
                                    <Typography
                                        typeDLS={TypographyTypeDLS.B1R}
                                        label={item?.label}
                                        color={ColorTokens.Grey_Charcoal}
                                    />
                                    <Typography
                                        typeDLS={TypographyTypeDLS.B1M}
                                        label={item?.value}
                                    />
                                </ThemedView>
                                {i != productDetails.length - 1 ? (
                                    <ThemedView marginVertical='lg'>
                                        <ThemedView height={1} backgroundColor='border-secondary' />
                                    </ThemedView>
                                ) : null}
                            </>
                        )
                    })}
                </ThemedView>
            </ThemedView>
        </ThemedView>
        </ScreenWrapper>
    )
}

export default ProductDetails

const styles = StyleSheet.create({})